import { render } from "./AccountRegistrationInstitutionDetail.vue?vue&type=template&id=29b340b4"
import script from "./AccountRegistrationInstitutionDetail.vue?vue&type=script&lang=js"
export * from "./AccountRegistrationInstitutionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__